export type Division = {
  id: string;
  code?: string;
  name?: string;
  origin: number | null;
  originString?: string;
  isFromManager: boolean;
  isActive?: boolean;
};

export enum eDivision {
  Sales = 0,
  Purchase = 1,
  Inventory = 2,
  Financial = 3,
  Marketing = 4,
  Other = 5,
}
